import React from 'react';
import { Skeleton } from '@mui/material';
import { useSpring, animated } from '@react-spring/web';
import { getCurrencySymbolV2 } from 'utils/currency';
import { useSelector } from 'react-redux';

// ✅ Clear
const StatsCountComponent = ({ name, count, isLoading, icon, type = 'integer' }) => {
    const cardStyle = {
        height: '100%',
        backgroundColor: '#fff',
        padding: '20px',
        borderRadius: '8px',
        border: '1px solid #e9ecef',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    };

    const contentStyle = {
        display: 'flex',
        alignItems: 'center',
        gap: '15px'
    };

    const textContainer = {
        textAlign: 'left'
    };

    const countStyle = {
        fontSize: '20px',
        fontWeight: '600',
        color: '#212529',
        lineHeight: '1.2'
    };

    const nameStyle = {
        fontSize: '0.875rem',
        color: '#6c757d',
        margin: '0'
    };

    const selectedCurrency = useSelector((state) => state.main.selectedCurrency);

    const { number } = useSpring({
        from: { number: 0 },
        to: count ?? 0,
        delay: 0,
        config: { mass: 1, tension: 120, friction: 14 },
    });

    const { animatedCounting } = useSpring({
        from: { animatedCounting: 0 },
        to: { animatedCounting: count },
        delay: 0,
        config: { mass: 1, tension: 120, friction: 14 },
    });

    if (isLoading) {
        return (
            <div style={cardStyle}>
                <div style={contentStyle}>
                    <Skeleton variant="circular" width={40} height={40} />
                    <div style={{ flex: 1 }}>
                        <Skeleton variant="text" width={'80%'} height={30} />
                        <Skeleton variant="text" width={'50%'} height={20} />
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div style={cardStyle}>
            <div style={contentStyle}>
                <div style={{ color: '#0068fa' }}>
                    {icon}
                </div>
                <div style={textContainer}>
                    <div className="flex gap-1">
                        {
                            type === 'float' && (
                                <div style={{ fontSize: '17px', marginTop: `${selectedCurrency === 'aed' ? '-1px' : '0' }`}}>
                                    {getCurrencySymbolV2(selectedCurrency, 'usd', '11px', '11px')}
                                </div>
                            )
                        }

                        {
                            type === 'float' ? (
                                <animated.div style={countStyle}>
                                    {animatedCounting.to((val) => val.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))}
                                </animated.div>
                            ) : (
                                <animated.div style={countStyle}>
                                    {number.to(n => n.toFixed(0).toLocaleString())}
                                </animated.div>
                            )
                        }
                    </div>
                    <p style={nameStyle}>{name}</p>
                </div>
            </div>
        </div>
    );
};

export default StatsCountComponent;